import { render, staticRenderFns } from "./prev-high-building.vue?vue&type=template&id=5ec57fe9&"
import script from "./prev-high-building.vue?vue&type=script&lang=js&"
export * from "./prev-high-building.vue?vue&type=script&lang=js&"
import style0 from "./prev-high-building.vue?vue&type=style&index=0&id=5ec57fe9&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports